import { put, call, takeLatest, all } from 'redux-saga/effects';
import shortid from 'shortid';
import { addWysiwygAudioModalActionTypes } from './Constants';
import * as addAudioActions from './Actions';
import * as errorHandlerActions from '../../errorHandler/Actions';
import { uploadFileHelper } from '../../../pagesNext/shared/Sagas';

export default function* () {
	yield all([
		yield takeLatest(
			addWysiwygAudioModalActionTypes.UPLOAD_WYSIWYG_AUDIO_REQUEST,
			handleUploadAudioRequest,
		),
	]);
}

export function* handleUploadAudioRequest({ payload }) {
	try {
		const { data: requestData } = payload || {};
		const { file, options, addEmbedBlock, editData } = requestData || {};
		const { id, src } = editData || {};

		const { linkToFile } = editData
			? { linkToFile: src }
			: yield call(uploadFileHelper, 'questions', file);

		addEmbedBlock(
			{
				id: shortid.generate(),
				src: src || linkToFile,
				options,
			},
			id
				? {
						id,
						src,
						options,
				  }
				: null,
			'audio',
		);

		yield put(addAudioActions.uploadAudioSuccess());
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'notification'));
		yield put(addAudioActions.uploadAudioError());
	}
}
